import AmplitudeHelper from '@utils/analytics';
import { AMPLITUDE_CONSTANTS } from '@utils/analytics/constants';

interface LogReferralApplicableParams {
  source: string;
}

export default function logReferralApplicable({ source }: LogReferralApplicableParams): void {
  const e = AMPLITUDE_CONSTANTS.redeemptionFlow.referral_code_applicable;
  const { name, attributes } = e;
  AmplitudeHelper.logEvent(name, { [attributes.source]: source });
}
